import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams } from 'src/app/models';
import { TagsList } from 'src/app/models/tag.model';
import { DialogModalService, LanguageService, NotificationService } from 'src/app/services';
import { ApiTagsService } from 'src/app/services/api-tags.service';
import { ConfirmActionComponent } from '../../confirm/confirm-action/confirm-action.component';
import { TagsActionsComponent } from '../tags-actions/tags-actions.component';

@Component({
  selector: 'app-tags-list',
  templateUrl: './tags-list.component.html',
  styleUrls: ['./tags-list.component.css']
})
export class TagsListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  tagsList: TagsList[] = [];
  tagsIDs: string[] = [];
  countSelectedFiles: number = 0;

  @Input() set data(value) {

    if (value != null) {

      this.tagsIDs = value.tagsIds;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private notification: NotificationService,
    private dialogModal: DialogModalService,
    private apiTagsService: ApiTagsService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getList();

    this.subscriptions.add(
      this.apiTagsService.listenerTagListData().subscribe(val => {

        if (val) {

          this.getList();
        }

      })
    );
  }

  /**
   * 
   */
  getList(): void {

    let params: ReferenceParams = {
      ref_name: 'tags',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiTagsService.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("TAGS LIST: ", response);

        if (response != null) {

          this.tagsList = response.result;

          if (this.tagsList.length > 0) {
            this.passSecurity();
            this.selectCheckboxeByIds(this.tagsIDs);
            this.counterSelectedFiles();
          }

        }
      })
    );

  }

  /**
   * 
   * @param ids 
   */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiTagsService.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

 
  /**
   * 
   */
  sendData() {

    this.activeModal.close(this.tagsList.filter(val => val.checked));

  }


  /**
   * 
   */
  onAction(tagId: string = null): void {

    this.dialogModal.open(tagId, TagsActionsComponent).then(
      (result) => {

        if (result) {
          
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.tagsList[index].checked = event.target.checked;

    this.counterSelectedFiles();
  }

  /**
 * 
 */
  counterSelectedFiles() {

    this.countSelectedFiles = this.tagsList.filter(val => val.checked).length;

  }

  /**
 * 
 */
  deleteSelected(): void {

    let ids = [...new Set(this.tagsList.filter(val => val.checked).map(({ id }) => id))];
    this.onConfirm(ids);
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    let pc = this.tagsList.filter(val => val.checked).length;

    this.tagsList.forEach(x => pc > 0 ? x.checked = false : x.checked = event.target.checked);

    this.counterSelectedFiles();

    this.storageForChekcedFiles();
  }

  /**
 * 
 */
  storageForChekcedFiles() {

    // this.files.forEach((x, i) => x.checked ? this.selectedFiles.push(x) : this.selectedFiles.splice(i, 1));

    this.tagsList.findIndex(i => i.checked);

    console.log("SELECTED TAGS: ", this.tagsList);
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.tagsList.length == 0) return false;

    return this.tagsList.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.tagsList.length;
    let pc = this.tagsList.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.tagsList.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }

  /**
   * 
   * @param ids 
   */
  selectCheckboxeByIds(ids: string[]) {

    if (ids == null || ids.length == 0) return;

    for (let id of ids) {

      let index = this.tagsList.findIndex(val => val.id == id);

      if (index > -1 && this.tagsList.length > 0) {

        this.tagsList[index].checked = true;
      }
    }

  }

  /**
   * 
   * @param ids 
   */
  passSecurity() {

    let primitiveParams: string;

    for (let l of this.tagsList) {

      primitiveParams = l.graphic_primitive.primitive_params
      primitiveParams = primitiveParams.replace('color', l.color)
      l['tagHtml'] = this.sanitizer.bypassSecurityTrustHtml(primitiveParams) as SafeHtml;
    }

  }


  onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }


  /**
   * 
   * @param styles 
   * @returns 
   */
  getTagStyle(styles) {
    return {
      width: styles.width + styles.width_height_unit,
      height: styles.height + styles.width_height_unit,
      display: 'block',
      margin: '0 5px 0 0'
    }
  }

}
